import { Outlet } from 'react-router-dom';

export const HardDeleteOutlet = () => <Outlet />;
